import { Palette } from '@mui/material';
import { CSSProperties } from 'react';

import { CustomThemeInterface } from '../../../interface/custom-theme';

// Sfondo, bordo e raggio delle righe di riepilogo (classe "single-recap"), dai colori delle
// schede e dal rettangolo del tema dell'insegna. Condiviso con le righe dello Smart
// multi-store, che hanno la stessa resa dei riepiloghi in alto.
export const getRecapStyle = (
  palette: Palette,
  rectangle?: CustomThemeInterface['rectangle']
): CSSProperties => ({
  backgroundColor: palette.card.main,
  border: `${rectangle?.borderWidth ?? 1}px solid ${palette.card.border ?? ''}`,
  borderRadius: rectangle?.borderRadius ?? '1px',
});
